import React, { useState } from 'react';
import Table from 'ui-components/table/table';
import { getLanesByDay } from './getLanesByDay';
import { useLanesByDay } from './hooks/useLanes';
import UpdateSidebar from './sidebars/updateSidebar';
import { useLaneByPlanID } from './hooks/useLanes';
import { setPlanId, setSourceDay, setTurnNumber, staticLoadSelector } from 'slices/static-load/staticLoadSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useTerminalDetailsByNumbers } from './hooks/useTerminalDetailsByNumbers';
import { formatTerminalsByNumber } from './utils/utils';
import { useCopyLaneToDay } from './hooks/useLanes';
import CopyMoveLaneSidebar from './sidebars/copyMoveLaneSidebar';
import AddDropSidebar from './sidebars/addDropSidebar';
import { useDeleteLane } from './hooks/useLanes';
import { useCarrier } from './hooks/useCarrier';

interface LanesByDayProps {
  dayOfWeek: string;
}

const LanesByDay: React.FC<LanesByDayProps> = ({ dayOfWeek }) => {
  const dispatch = useDispatch();

  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isCopyOpen, setIsCopyOpen] = useState<boolean>(false);
  const [isAddDropOpen, setIsAddDropOpen] = useState<boolean>(false);
  const [copyType, setCopyType] = useState<'copy' | 'move'>('copy');

  const staticLoadSelectorData = useSelector(staticLoadSelector);
  const selectedPlanId = staticLoadSelectorData.selectedPlanId;
  const selectedDivision = staticLoadSelectorData.selectedDivision;
  const weekStartDate = staticLoadSelectorData.weekStartDate;
  const copyLaneToDayMutation = useCopyLaneToDay();
  const deleteLaneMutation = useDeleteLane();


  const { data: lanesByDay, refetch: refetchLanesByDay } = useLanesByDay(selectedDivision, weekStartDate, dayOfWeek)

  const { data: laneByPlanId, isLoading: isLoadingLaneByPlanID, refetch: refetchLaneByPlanID } = useLaneByPlanID(selectedPlanId, selectedDivision, weekStartDate)

  const { data: carrierData } = useCarrier()

  const terminalNumbers =
    laneByPlanId?.drops?.map(d => d.terminalNumber) ?? [];

  const {
    data: terminalDetails,
  } = useTerminalDetailsByNumbers(terminalNumbers);

  const handleEdit = (planId: string, type: string, turnNumber?: number) => {

    dispatch(setPlanId(planId));
    if (type === 'edit') {
      setIsEditMode(true);
      setIsOpen(true)
    }
    else if (type === 'view') {
      setIsEditMode(false);
      setIsOpen(true);
    }
    else if (type === 'copy') {
      setIsEditMode(false);
      setIsCopyOpen(true);
      setCopyType('copy');
      dispatch(setSourceDay(dayOfWeek));
      if (turnNumber) {
        dispatch(setTurnNumber(turnNumber.toString()));
      }
    }
    else if (type === 'move') {
      setIsEditMode(false);
      setIsCopyOpen(true);
      setCopyType('move');
      dispatch(setSourceDay(dayOfWeek));
      if (turnNumber) {
        dispatch(setTurnNumber(turnNumber.toString()));
      }
    }

    else if (type === 'delete') {
      deleteLaneMutation.mutate(planId, {
        onSuccess: () => {
          refetchLanesByDay();
        }
      });

    }
  }

  const terminalMap = formatTerminalsByNumber(terminalDetails);

  const handleAddDrop = () => {
    setIsAddDropOpen(true)
  };

  return (
    <div>
      <Table
        columns={getLanesByDay(handleEdit, carrierData)}
        data={lanesByDay?.[dayOfWeek] ?? []}
        infiniteScroll
        rowHeight={56}
        minTableHeight={320}
      />
      <UpdateSidebar
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        data={laneByPlanId || { lane: {}, drops: [] }}
        isLoading={isLoadingLaneByPlanID}
        terminalMap={terminalMap}
        isEditMode={isEditMode}
        refetchLane={refetchLaneByPlanID}
        refetchLaneByDay={refetchLanesByDay}
        handleAddDrop={handleAddDrop}
      />
      <CopyMoveLaneSidebar
        isOpen={isCopyOpen}
        onClose={() => setIsCopyOpen(false)}
        isLoading={false}
        copyLaneToDayMutation={copyLaneToDayMutation}
        type={copyType}
      />
      <AddDropSidebar
        isOpen={isAddDropOpen}
        onClose={() => setIsAddDropOpen(false)}
        refetchLaneByPlanID={refetchLaneByPlanID}
      />
    </div>
  );

};

export default LanesByDay;
